// @material-ui/icons
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Settings from "@material-ui/icons/SettingsApplications";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Audit from "@material-ui/icons/TrackChanges";
import AirlineRouteIcon from "@material-ui/icons/Flight";
import Landing from "@material-ui/icons/FlightLandOutlined";
import Receipt from "@material-ui/icons/Receipt";
import PscSettings from "@material-ui/icons/SettingsBackupRestore";
import Email from "@material-ui/icons/Email";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import NotFound from "views/NotFound/Index.jsx";

import AirlinesPassengerPage from "Regional-Views/AirlinesPassenger/Index.jsx";
import AirlinePaymentPage from "Regional-Views/AirlinePayment/Index.jsx";
import SettlementPage from "Regional-Views/Settlement/Index.jsx";
import SettingsPage from "Regional-Views/Settings/Index.jsx";
import InvoiceApproval from "Regional-Views/InvoiceApproval/Index";
import ExchangeRate from "Regional-Views/ExchangeRate/Index.jsx";
import ExchangeRateAirlineView from "Regional-Views/ExchangeRateAirline/airlineView.js";
import AirlineRouteSetting from "Regional-Views/AirlineRouteSettings";
import BillablePscSettings from "Regional-Views/BillablePscSettings/Index.jsx"
import EmailSettings from "Regional-Views/EmailSettings/Index.jsx";
import PscSettingsTable from "Regional-Views/PscSettings/Index.jsx";
import HelpCenter from "../Regional-Views/HelpCenter/index"
import HelpIcon from "@material-ui/icons/HelpOutline"

const dashboardRoutes = [
  {
    path: "/main-landing",
    sidebarName: "Main Landing",
    navbarName: "Main Landing",
    icon: Landing,
    component: MainLandingPage,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/passenger-data",
    sidebarName: "Passenger Data",
    navbarName: "Airline Passenger Data",
    icon: Passenger,
    subMenu: [],
    component: AirlinesPassengerPage
  },
  {
    path: "/app/psc-regional/airline-payment",
    sidebarName: "Airline Payment",
    navbarName: "Airline Payment Report",
    icon: Flight,
    subMenu: [],
    component: AirlinePaymentPage
  },
  {
    path: "/app/psc-regional/invoice-approval",
    sidebarName: " Payment Approval",
    navbarName: "Payment Approval",
    icon: Receipt,
    subMenu: [],
    component: InvoiceApproval
  },
  {
    path: "/app/psc-regional/psc-settlement",
    sidebarName: " PSC Settlement",
    navbarName: "PSC Settlement",
    icon: Settlement,
    subMenu: [],
    component: SettlementPage
  },
  {
    path: "/app/psc-regional/exchange-rate",
    sidebarName: "Exchange Rate",
    navbarName: "Exchange Rate",
    icon: AirlineRouteIcon,
    subMenu: [],
    component: ExchangeRateAirlineView,
  },
  {
    path: "/app/psc-regional/settings",
    sidebarName: "Settings",
    navbarName: "Settings",
    subMenu: [
      {
        path: "/app/psc-regional/settings",
        sidebarName: "Re-order Level",
        navbarName: "Re-order Level",
        component: SettingsPage
      },
      {
        path: "/app/psc-regional/pscSettings",
        sidebarName: "PSC Settings",
        navbarName: "PSC Settings",
        icon: PscSettings,
        component: PscSettingsTable
      },
      {
        path: "/app/psc-regional/emailSettings",
        sidebarName: "Email Settings",
        navbarName: "Email Settings",
        icon: Email,
        component: EmailSettings
      },
      {
        path: "/app/psc-regional/airlineRouteSettings",
        sidebarName: "Airline Routes",
        navbarName: "Airline Routes Settings",
        icon: AirlineRouteIcon,
        component: AirlineRouteSetting
      },
      {
        path: "/app/psc-regional/billableSettings",
        sidebarName: "Billable Passenger",
        navbarName: "Billable Passenger Settings",
        icon: AirlineRouteIcon,
        component: BillablePscSettings,
    
      },
      {
        path: "/app/psc-regional/exchangeRate",
        sidebarName: "Exchange Rate Setup",
        navbarName: "Exchange Rate Setup",
        icon: AirlineRouteIcon,
        component: ExchangeRate,
      },
    ],
    icon: Settings,
    component: SettingsPage
  },
  {
    path: "/app/psc-regional/pscSettings",
    sidebarName: "PSC Settings",
    navbarName: "PSC Settings",
    icon: PscSettings,
    isNotVisible: true,
    component: PscSettingsTable,
    subMenu: [],
    
  },
  {
    path: "/app/psc-regional/airlineRouteSettings",
    sidebarName: "Airline Routes",
    navbarName: "Airline Routes Settings",
    icon: AirlineRouteIcon,
    isNotVisible: true,
    component: AirlineRouteSetting,
    subMenu: []
  },
  {
    path: "/app/psc-regional/billableSettings",
    sidebarName: "Billable Passenger",
    navbarName: "Billable Passenger Settings",
    icon: AirlineRouteIcon,
    component: BillablePscSettings,
    isNotVisible: true,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/emailSettings",
    sidebarName: "Email Settings",
    navbarName: "Email Settings",
    icon: Email,
    isNotVisible: true,
    component: EmailSettings,
    subMenu: [],
    
  },
  {
    path: "/app/psc-regional/exchangeRate",
    sidebarName: "Exchange Rate",
    navbarName: "Exchange Rate",
    icon: AirlineRouteIcon,
    component: ExchangeRate,
    isNotVisible: true,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/help-center",
    sidebarName: "Help Center",
    navbarName: "Help Center",
    icon: HelpIcon,
    component: HelpCenter,
    subMenu: []
  },
  {
    isNotVisible: true,
    path: "**",
    sidebarName: "Not found",
    navbarName: "Not Found",
    icon: Audit,
    subMenu: [],
    component: NotFound,
    
  }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/regional-HQ-supervisor.js